var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"smole-padding",attrs:{"depressed":"","color":"editcolor","disabled":_vm.disabled},on:{"click":_vm.edit}},[_c('span',{staticClass:"material-icons smole-size"},[_vm._v("edit")]),_vm._v("編集")])}
var staticRenderFns = []

export { render, staticRenderFns }